import { render, staticRenderFns } from "./urgingSalesList.vue?vue&type=template&id=aa880fca"
import script from "./urgingSalesList.vue?vue&type=script&lang=js"
export * from "./urgingSalesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports